// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"a1cf3aa202eda24acc64","661":"7440a4ff92141f035f75"}[chunkId] + ".chunk.js";
};